import { datadogRum } from '@datadog/browser-rum';
import { useQueryClient } from '@tanstack/react-query';
import { signOut } from 'next-auth/react';
import { onLogout } from 'utils/webview';

const useAuth = () => {
  const queryClient = useQueryClient();

  const logout = async () => {
    await signOut({ redirect: true, callbackUrl: window.location.origin });
    await queryClient.invalidateQueries();
    datadogRum.clearUser();
    onLogout();

    return true;
  };

  return { logout };
};

export default useAuth;
